if (!window.customElements.get('td-product-recommendations')) {
    class TdProductRecommendations extends HTMLElement {
        constructor() {
            super();
    
            this.parentSwiper = this.closest('swiper-slider');
            this.wrapper = this.closest('.td-cart-drawer__recommended-slider-wrapper');
           
        }
        fetchProducts() {
            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
               
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    
                    const recommendations = html.querySelector('.td-product-recommendations__container');
                    
                    if(recommendations) {
                        const recs = Array.from(recommendations.children)
                        recs.map((rec) => {                            
                            this.appendChild(rec)
                        })
                       if(this.wrapper) this.wrapper.classList.remove('td-hide')
                       if(this.parentSwiper) {
                            const recentlyViewedRendered = new Event('related-initialized');
                            this.parentSwiper.dispatchEvent(recentlyViewedRendered);
                       }
                        
                    }
                  
    
                })
                .catch(e => {
                    console.error(e);
                });
        }
        connectedCallback() {
            this.fetchProducts();
        }
    }
    
    customElements.define('td-product-recommendations', TdProductRecommendations);
    }
    